export { default } from './src/components/resource-dialog';